import { render } from "./Acl.vue?vue&type=template&id=69c9292a&ts=true"
import script from "./Acl.vue?vue&type=script&lang=ts"
export * from "./Acl.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/askom/io.askom.portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__